import React from 'react'
import LayoutMain from '../../layouts/LayoutMain'
import MyBlock from '../../UI/block/MyBlock'
import SubmenuUser from '../submenu/SubmenuUser'
import MyBlockHeader from '../../UI/block/MyBlockHeader'
import UserWorkPlaceForm from './form/UserWorkPlaceForm'
import UserWorkPlaceVisible from './visible/UserWorkPlaceVisible'

const UserWorkPlace = () => {
  return (
    <LayoutMain>
		<MyBlock>
			<SubmenuUser />
		</MyBlock>
        <MyBlockHeader
            header={'Робоче місце'}
            // isBack={true}
            // options={
            //     <UserInfoOptions />
            // }
        />
        {/* <MyBlock>
            <BoxOneOptions 
                boxId={boxId}
            />
        </MyBlock> */}
		<MyBlock>
			<UserWorkPlaceVisible />
		</MyBlock>
    </LayoutMain>
  )
}

export default UserWorkPlace